// extracted by mini-css-extract-plugin
export var primitiveLabel = "_v0-0";